import * as React from "react";
import { useTranslation } from "react-i18next";

import { Box, Button } from "@mui/material";

import { COLORS } from "./constants";

export type InventoryTab = "confirm" | "activate" | "sales" | "settlement";

interface InventoryTabsProps {
  active: InventoryTab;
  onConfirmClick?: () => void;
  onActivateClick?: () => void;
  onSalesClick?: () => void;
  onSettlementClick?: () => void;
}

interface TabDef {
  id: InventoryTab;
  label: string;
  onClick?: () => void;
  // Sales & Settlement are planned for a later phase -> rendered but disabled
  disabled?: boolean;
}

// Top navigation for the inventory module. Confirm is the current screen,
// Activate opens the activate popup, Sales & Settlement are disabled placeholders.
const InventoryTabs: React.FC<InventoryTabsProps> = ({ active, onConfirmClick, onActivateClick, onSalesClick, onSettlementClick }) => {
  const { t } = useTranslation("translation");

  const tabs: TabDef[] = [
    { id: "confirm", label: t("confirmTabLabel", "Confirm"), onClick: onConfirmClick },
    { id: "activate", label: t("activateTabLabel", "Activate"), onClick: onActivateClick },
    { id: "sales", label: t("salesTabLabel", "Sales"), onClick: onSalesClick },
    // Settlement is planned for a later phase -> rendered but disabled unless a handler is provided
    { id: "settlement", label: t("settlementTabLabel", "Settlement"), onClick: onSettlementClick, disabled: !onSettlementClick },
  ];

  return (
    <Box display='flex' alignItems='center' gap='12px' flexWrap='wrap'>
      {tabs.map((tab) => {
        const isActive = tab.id === active;
        return (
          <Button
            key={tab.id}
            onClick={tab.onClick}
            disabled={tab.disabled}
            disableElevation
            sx={{
              minWidth: "120px",
              height: "38px",
              borderRadius: "10px",
              textTransform: "none",
              fontSize: "18px",
              fontWeight: 600,
              color: "#fff",
              backgroundColor: isActive ? COLORS.orange : COLORS.navy,
              opacity: tab.disabled ? 0.5 : 1,
              "&:hover": {
                backgroundColor: isActive ? COLORS.orange : COLORS.navy,
                opacity: tab.disabled ? 0.5 : 0.9,
              },
              "&.Mui-disabled": { color: "#fff" },
            }}
          >
            {tab.label}&nbsp;&nbsp;+
          </Button>
        );
      })}
    </Box>
  );
};

export default InventoryTabs;
